import { ref, computed } from 'vue';
import CeoDashboardAPI from 'dashboard/api/captain/ceoDashboard';
import ReportsAPI from 'dashboard/api/reports';

const PERIODS = {
  LAST_7_DAYS: { days: 7, key: 'LAST_7_DAYS' },
  LAST_30_DAYS: { days: 30, key: 'LAST_30_DAYS' },
  LAST_90_DAYS: { days: 90, key: 'LAST_90_DAYS' },
};

export const useCeoDashboard = () => {
  const selectedPeriod = ref(PERIODS.LAST_7_DAYS);
  const isLoading = ref(false);
  const ceoDashboardData = ref(null);
  const reportsSummary = ref(null);
  const botMetrics = ref({});
  const previousReportsSummary = ref(null);
  const previousBotMetrics = ref({});

  const dateRange = computed(() => {
    const now = Math.floor(Date.now() / 1000);
    const from = now - selectedPeriod.value.days * 86400;
    return { from, to: now };
  });

  const previousDateRange = computed(() => {
    const now = Math.floor(Date.now() / 1000);
    const from = now - selectedPeriod.value.days * 2 * 86400;
    const to = now - selectedPeriod.value.days * 86400;
    return { from, to };
  });

  const fetchAll = async () => {
    isLoading.value = true;
    try {
      const range = dateRange.value;
      const prevRange = previousDateRange.value;

      const [ceoRes, summaryRes, botRes, prevSummaryRes, prevBotRes] =
        await Promise.all([
          CeoDashboardAPI.get({ since: range.from, until: range.to }),
          ReportsAPI.getSummary(range.from, range.to),
          ReportsAPI.getBotSummary({
            from: range.from,
            to: range.to,
            groupBy: 'day',
          }),
          ReportsAPI.getSummary(prevRange.from, prevRange.to),
          ReportsAPI.getBotSummary({
            from: prevRange.from,
            to: prevRange.to,
            groupBy: 'day',
          }),
        ]);

      ceoDashboardData.value = ceoRes.data;
      reportsSummary.value = summaryRes.data;
      botMetrics.value = botRes.data || {};
      previousReportsSummary.value = prevSummaryRes.data;
      previousBotMetrics.value = prevBotRes.data || {};
    } catch {
      // Silently handle -- auto-refresh will retry
    } finally {
      isLoading.value = false;
    }
  };

  const setSelectedPeriod = period => {
    selectedPeriod.value = period;
  };

  return {
    PERIODS,
    selectedPeriod,
    dateRange,
    isLoading,
    ceoDashboardData,
    reportsSummary,
    botMetrics,
    previousReportsSummary,
    previousBotMetrics,
    fetchAll,
    setSelectedPeriod,
  };
};
